<template>
  <div class="exam">
    <div class="nuv">
      <a :href="'/tjkStudy/waitWork?groupId='+groupId+'&groupName='+groupName" target="_blank" class="active">群待岗学员</a>&gt;
      <span>群待岗学员群考核</span>&gt;
      <span>{{ codeName }}</span>
    </div>
    <div class="end">
      <el-button type="primary" @click="endExam()">结束考核</el-button>
      <span>剩余{{ waitNum }}人待考核</span>
      <span>当前拨打电话：{{ callOutPhone }}</span>
      <el-button type="primary" @click="changePhone">修改电话号码</el-button>
    </div>
    <template v-if="status">
      <p class="nopeople">名单中全部人员考核结束</p>
    </template>
    <template v-else>
      <div class="current">
        <div class="tab">
          <span>当前考核人员：</span>
          <template v-if="!!userList.current">
            <span>【{{ userList.current.realName }}】</span>
            <span>
              <template v-if="userList.current.userState == 'Calling'">正在外呼</template>
              <template v-if="userList.current.userState == 'Confirmed'">已确认</template>
              <template v-if="userList.current.userState == 'Unconfirmed'">未确认</template>
              <template v-if="userList.current.userState == 'Call'">通话中</template>
              <template v-if="userList.current.userState == 'Callend'">通话结束</template>
            </span>
          </template>
        </div>
        <div class="content">
          <p class="button">
            <el-button type="success" @click="saveScore('Passed')">录取</el-button>
            <el-button type="info" @click="saveScore('Failed')">不录取</el-button>
            <el-button type="warning" @click="saveScore('Pending')">待定</el-button>
          </p>
        </div>
      </div>
      <div class="next">
        <div class="tab">
          <span>接下来考核人员：</span>
          <template v-if="!!userList.next">
            <span>【{{ userList.next.realName }}】</span>
            <span>
              <template v-if="userList.next.userState == 'Calling'">正在外呼</template>
              <template v-if="userList.next.userState == 'Confirmed'">已确认</template>
              <template v-if="userList.next.userState == 'Unconfirmed'">未确认</template>
              <template v-if="userList.next.userState == 'Call'">通话中</template>
              <template v-if="userList.next.userState == 'Callend'">通话结束</template>
            </span>
          </template>
          <template v-else>暂无</template>
        </div>
      </div>
    </template>
    <p v-if="!success" class="tj-shift-notice">{{ message }}</p>
    <template v-else>
      <p class="tj-shift-notice" v-if="!list.length">暂无记录！</p>
      <template v-else>
        <h3>考核名单</h3>
        <el-table :data="list" border>
          <el-table-column prop="examineSeq" label="顺序" width="180"></el-table-column>
          <el-table-column prop="realName" label="考核人员" width="180"></el-table-column>
          <el-table-column prop="tjkNumber" label="淘金号" width="180"></el-table-column>
          <el-table-column label="状态" width="180">
            <template slot-scope="scope">
              <template v-if="scope.row.examineState == 'Examining'">正在考核</template>
              <template v-if="scope.row.examineState == 'Examined'">已考核</template>
              <template v-if="scope.row.examineState == 'Wait'">待考核</template>
              <template v-if="scope.row.examineState == 'Abandon'">学员放弃</template>
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="考核开始时间"></el-table-column>
          <el-table-column prop="duration" label="考核时长">
            <template slot-scope="scope">
              {{ formatTime(scope.row.duration) }}
            </template>
          </el-table-column>
          <el-table-column label="是否录取">
            <template slot-scope="scope">
              <template v-if="scope.row.passState == 'Passed'">是</template>
              <template v-if="scope.row.passState == 'Failed'">否</template>
              <template v-if="scope.row.passState == 'Pending'">待定</template>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </template>
    <!-- 修改外呼电话弹出层 -->
    <Modal ref="change">
      <div class="tj-table tj-fill tj-padding-right-xl">
        <dl>
          <dt class="tj-text-right"><font color="red">*</font> 外呼电话：</dt>
          <dd>
            <el-input placeholder="请输入内容" v-model="change.callOutPhone" clearable></el-input>
          </dd>
        </dl>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      'success': true,
      'message': '',
      'groupId': this.$route.query.groupId,
      'groupName': this.$route.query.groupName,
      'tjkId': '', //当前考核人员的tjkId
      'userList': {}, //当前和下一个考核人员信息
      'list': [], //考核名单列表
      'waitNum': '', //剩余考核人数
      'callOutPhone': '', //当前外呼电话号码
      'codeName': '', //当前考核代号
      'examineRecordId': this.$route.query.id, //当前考核记录id
      'examineId': '', //群考核记录id
      'change': {
        callOutPhone: ''
      }, //修改外呼电话 
      'interval': null, //轮询状态
      'status': false //是否考核完成 无考核人员和结束考核后为true
    }
  },
  mounted: function() {
    this.initUser()
    this.intervalFun()
    this.getList()
  },
  methods: {
    myAlert(msg){
      this.$alert(msg, '系统提示', {
        confirmButtonText: '确定',
        callback: action => {
          
        }
      })
    },
    //轮询代码
    intervalFun() {
      let self = this
      self.interval = setInterval(() => {
        console.log('this is heartbeat...')
        this.initUser()
      }, 5000)
    },
    //查询当前和下一个考核人员信息
    initUser() {
      var data = {
        'examineRecordId': this.examineRecordId
      }
      this.$http.post(API_ROOT.college + '/voice/examine/userState', data).then(response => {
        var result = response.data
        if(result.success) {
          this.success = result.success
          this.message = result.msg
          this.userList = result.data
          this.tjkId = !!result.data.current ? result.data.current.tjkId : ''
          this.waitNum = result.data.waitNum
          this.callOutPhone = result.data.callOutPhone
          this.codeName = result.data.codeName
          this.examineId = (!!result.data.current && !!result.data.current.evaluation) ? result.data.current.evaluation.examineId : ''
          if(!result.data.current && !result.data.next) {
            this.status = true
            this.endExam()
            clearInterval(this.interval)
          }
        }else {
          this.myAlert(result.msg)
        }
      }, response => {
        this.myAlert('网络繁忙，请稍后重试！')
      })
    },
    //查询考核名单列表
    getList() {
      var data = {
        'examineRecordId': this.examineRecordId
      }
      this.$http.post(API_ROOT.college + '/voice/examine/manageView', data).then(response => {
        var result = response.data
        if(result.success) {
          this.success = result.success
          this.message = result.msg
          this.list = result.data
        }else {
          this.myAlert(result.msg)
        }
      }, response => {
        this.myAlert('网络繁忙，请稍后重试！')
      })
    },
    //时间格式化
    formatTime(time) {
      if(!!time) {
        let h = parseInt(time / (60 * 60))
        let m = parseInt((time % (60 * 60)) / 60)
        let s = parseInt((time % (60 * 60)) % 60)
        return (h >= 10 ? h : '0' + h) + ':' + (m >= 10 ? m : '0' + m) + ':' + (s >= 10 ? s : '0' + s)
      }else {
        return ''
      }
    },
    //语音考核打分并标记是否通过
    saveScore(passState) {
      var reg = /^[1-9]\d*|0$/
      if((!!this.score && !reg.test(this.score))) {
        this.myAlert('分数只能是非负整数')
        return false
      }
      if(!!this.remark && this.remark.length > 200) {
        this.myAlert('备注不能超过200字')
        return false
      }
      this.saveScoreFun(passState)
    },
    //保存打分
    saveScoreFun(passState) {
      var data = {
        'groupId': this.groupId,
        'tjkId': this.tjkId,
        'examineId': this.examineId,
        'passState': passState
      }
      this.$http.post(API_ROOT.college + '/waitJob/examine/score', data).then(response => {
        var result = response.data
        if(result.success) {
          this.$message({
            message: '操作成功',
            type: 'success',
            center: true,
            duration: 1000
          })
          this.initUser()
          this.getList()
        }else {
          this.myAlert(result.msg)
        }
      }, response => {
        this.myAlert('网络繁忙，请稍后重试！')
      })
    },
    //考核结束
    endExam() {
      var data = {
        'groupId': this.groupId,
        'recordType': 'WaitJob'
      }
      this.$http.post(API_ROOT.college + '/voice/examine/end', data).then(response => {
        var result = response.data
        if(result.success) {
          this.status = true
          clearInterval(self.interval)
          window.location.href = '/tjkStudy/waitWork?groupId='+this.groupId+'&groupName='+this.groupName
        }else {
          this.myAlert(result.msg)
        }
      }, response => {
        this.myAlert('网络繁忙，请稍后重试！')
      })
    },
    //修改外呼电话
    changePhone() {
      var self = this
      self.change.callOutPhone = ''

      this.$confirm('修改学员拨打电话，下一位学员生效。是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs.change.open({
          title: '修改外呼电话',
          width: 600,
          callBack: function (arg) {
            if (arg.type === 'cancel') {
              arg.close()
              return
            }
            if(self.change.callOutPhone == '') {
              self.myAlert('外呼电话不能为空')
              return false
            }
            var reg = /^[0-9]*[1-9][0-9]*$/
            if(!reg.test(self.change.callOutPhone)) {
              self.myAlert('只能填写正整数')
              return false
            }
            if (arg.pending()) return
            arg.pending(true)

            var data = {
              'examineRecordId': self.examineRecordId,
              'callOutPhone': self.change.callOutPhone
            }
            self.$http.post(API_ROOT.college + '/voice/examine/updateCallOutPhone', data).then(response => {
              arg.pending(false)
              var result = response.data
              if(result.success) {
                self.$message({
                  message: '已修改',
                  type: 'success',
                  center: true,
                  duration: 1000
                })
                arg.close()
              } else {
                self.myAlert(result.msg)
              }
            }, response => {
              self.myAlert('网络繁忙，请稍后重试！')
            })
          }
        })
      }).catch(() => {
                 
      })
    }
  }
}
</script>
<style type="less" scoped>
  .nuv {
    font-size: 16px;
  }
  .current, .next {
    border: 1px solid #dfdfdf;
    background-color: #ffffff;
  }
  .current .tab, .next .tab {
    border-bottom: 1px solid #dfdfdf;
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
  }
  .next .tab {
    border-bottom: none;
  }
  .current .content {
    padding: 10px;
  }
  table > tr > th, table > tr > td {
    padding: 5px;
  }
  .content .button {
    margin: 0px 5px 10px 5px;
  }
  .next {
    margin: 20px 0;
  }
  .end {
    margin-bottom: 20px;
    margin-top: 10px;
  }
  .end > span {
    padding: 0 20px;
    font-size: 18px;
  }
  .gotoindex {
    margin: 20px 0;
  }
  .nopeople {
    padding: 10px 0 20px;
  }
</style>


// WEBPACK FOOTER //
// ./src/page/college/waitWorkExam.vue